var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0161 11.7929H1.2241C0.888098 11.7929 0.600098 12.0089 0.600098 12.3449V13.9769C0.600098 14.3129 0.888098 14.6729 1.2241 14.6729H16.9921C17.3281 14.6729 17.6161 14.2889 17.6161 13.9529V12.4169C17.6401 12.0569 17.3521 11.7929 17.0161 11.7929Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0161 6.03289H1.2241C0.888098 6.03289 0.600098 6.24889 0.600098 6.58489V8.21689C0.600098 8.55289 0.888098 8.91289 1.2241 8.91289H16.9921C17.3281 8.91289 17.6161 8.52889 17.6161 8.19289V6.65689C17.6401 6.29689 17.3521 6.03289 17.0161 6.03289Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0161 0.272888H1.2241C0.888098 0.272888 0.600098 0.488888 0.600098 0.824888V2.45689C0.600098 2.79289 0.888098 3.15289 1.2241 3.15289H16.9921C17.3281 3.15289 17.6161 2.76889 17.6161 2.43289V0.896888C17.6401 0.536888 17.3521 0.272888 17.0161 0.272888Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burgerIcon.a62851cfcec902bb436f33c93589d767.svg";
export { ForwardRef as ReactComponent };